import React from 'react';
import { IconProps } from '.';

const SvgFaceBadFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z' />
      <path
        fill='#fff'
        d='M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM9 17c0-1.66 1.34-3 3-3s3 1.34 3 3H9ZM17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z'
      />
    </svg>
  );
};

export default SvgFaceBadFill;
